import { render, staticRenderFns } from "./WameedModal.vue?vue&type=template&id=0aef9171&"
import script from "./WameedModal.vue?vue&type=script&lang=js&"
export * from "./WameedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports